export const RESET = "reset";
export const UPDATE_DATE = "setDate";
export const UPDATE_FILTER = "setFilter";
export const UPDATE_FILTER_DATE = "setFilterDate";
export const UPDATE_FILTER_STATUS = "setFilterStatus";
export const UPDATE_FILTER_SERVICE_TYPE = "setFilterServiceType";
export const UPDATE_FILTER_VEHICLE_TYPE = "setFilterVehicleType";
export const UPDATE_DATE_FROM = "setDateFrom";
export const UPDATE_DATE_UNTIL = "setDateUntil";
